export default "__VITE_ASSET__565e12b8__"